let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aCNiO")).then(() => parcelRequire('fPj8Q'));